import { getLandingRoute } from '@/features/settings/landing';
import { useAuthStatus } from '@/hooks/use-auth-status';
import { useQueryClient } from '@tanstack/react-query';
import { Redirect } from 'expo-router';
import React from 'react';

export default function Index() {
  const authStatus = useAuthStatus();
  const queryClient = useQueryClient();

  if (authStatus === 'verified') {
    // Honor the user's persisted default landing screen (read synchronously from
    // the hydrated cache — no fetch, no flash). Defaults to Discover.
    return <Redirect href={{ pathname: getLandingRoute(queryClient) }} />;
  }

  if (authStatus === 'loggedOut') {
    return <Redirect href={{ pathname: '/(auth)/login' }} />;
  }

  // Loading or unverified -- ProtectedRoutes handles these
  return null;
}
